export const getQueryParamValue = (param) => {
  const regex = new RegExp(`[?&]${param}(=([^&#]*)|&|#|$)`, "i");
  const results = regex.exec(window.location.href);

  if (!results) return null;

  return results[2] ? decodeURIComponent(results[2].replace(/\+/g, " ")) : null;
};

export const formatDateAccordingToLanguage = (strDate, language ="sv") => {

    if (strDate == "") {
        return "";
    }

    var date = new Date(strDate);
    var formattedDate = date.toLocaleDateString(language, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });

    return formattedDate;
}

export const getObjKey = (obj, value) => {
    return Object.keys(obj).find(key => obj[key] === value);
}